import React, { PureComponent } from 'react';
import { oneOf, objectOf, string } from 'prop-types';

export default class Merchandizing extends PureComponent {
    static propTypes = {
        type: oneOf([
            'topSales',
            'recommended',
            'productOfTheWeek',
            'mmf',
            'b2b',
        ]),
        translations: objectOf(string).isRequired,
    };

    static defaultProps = {
        type: 'topSales',
    };

    render() {
        const { type, translations } = this.props;
        const trans = {
            label: {
                topSales: 'Top ventes',
                recommended: 'Recommandé par Manomano',
                productOfTheWeek: 'Produit de la semaine',
                mmf: translations.banner_fulfillment_title,
            },
        };

        return (
            <div
                className={`product-card-merchandizing product-card-merchandizing--${type} js-tooltip-${type}`}
            >
                {trans.label[type]}
            </div>
        );
    }
}
